import { type InputHTMLAttributes } from 'react'

type CheckboxProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string
}

export const Checkbox = ({ label, ...props }: CheckboxProps) => {
  return (
    <label className="flex items-center gap-2">
      <input
        {...props}
        type="checkbox"
        className="inline-flex items-center justify-center flex-shrink-0 w-6 h-6 border rounded-md appearance-none border-grey-500 checked:border-primary-light checked:bg-primary-light before:self-end checked:before:content-checkIcon"
      />
      <span className="text-sm font-normal">{label}</span>
    </label>
  )
}
